/* eslint-disable camelcase */
module.exports = function (self) {
	return {
		async list({ search = null, offset = 0, only_fake = null, limit = self.limit }) {
			try {
				const response = await self.$http.get(
					'admin/users', {
						params: {
							search,
							only_fake: only_fake ? 1 : 0,
							offset,
							limit,
						},
						headers: {
							Authorization: true,
						},
					},
				);

				return {
					ok: true,
					data: response.data.users,
					error: null,
				};
			} catch (error) {
				return {
					ok: false,
					data: [],
					error: null,
				};
			}
		},
	};
};
